import _forEach from 'lodash/forEach';
import React from 'react'; // Ensure React is imported


import { LayerAlignmentItem, LayerPatternItem } from 'interfaces/calculator';
import { LayerAlignmentType, LayerPatternType } from 'enums/calculator';

import  {ReactComponent as HMirroredIcon}  from '@icons/layer-alignment/h-mirrored.svg';
import {ReactComponent as VMirroredIcon}  from '@icons/layer-alignment/v-mirrored.svg';
import {ReactComponent as RotatedIcon}  from '@icons/layer-alignment/rotated.svg';
import {ReactComponent as Parallel}  from '@icons/layer-alignment/parallel.svg';


// const HMirroredIcon = () =>
//   React.createElement('div', { dangerouslySetInnerHTML: { __html: _HMirroredIcon } });

// const VMirroredIcon = () =>
//   React.createElement('div', { dangerouslySetInnerHTML: { __html: _VMirroredIcon } });

// const RotatedIcon = () =>
//   React.createElement('div', { dangerouslySetInnerHTML: { __html: _RotatedIcon } });

// const Parallel = () =>
//   React.createElement('div', { dangerouslySetInnerHTML: { __html: _Parallel } });

interface Keys {
  [key: string]: Array<number>;
}

const baseData: Keys = {
  a: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 18],
  b: [4, 6, 9, 12, 13],
  c: [8, 10, 20],
  d: [6, 8, 9, 16],
  j: [10],
};



const makePatternsData = (): LayerPatternItem[] => {
  const data: LayerPatternItem[] = [];
  Object.keys(baseData).forEach((key) => {
    const dataKey = baseData[key];
    _forEach(dataKey, (value) => {
      const label = `${value}${key.toUpperCase()}`;
      data.push({
        value,
        label,
      });
    });
  });

  data.sort((a, b) => Number(b.value) - Number(a.value));
  data.unshift({ value: 0, label: 'Grid' });
  return data;
};


const items = makePatternsData();

const alignmentItems: LayerAlignmentItem[] = [
  {
    id: LayerAlignmentType.H_MIRRORED,
    label: 'H-mirrored',
    Icon: HMirroredIcon,
  },
  {
    id: LayerAlignmentType.V_MIRRORED,
    label: 'V-mirrored',
    Icon: VMirroredIcon,
  },
  {
    id: LayerAlignmentType.ROTATED,
    label: 'Rotated',
    Icon: RotatedIcon,
  },
  {
    id: LayerAlignmentType.PARALLEL,
    label: 'Parallel',
    Icon: Parallel,
    selected: true,
  },
];

const layerDefaultState = {
  units: null,
  pattern: {
    type: LayerPatternType.ALIGNED,
    items,
    activeItem: items && items[0],
  },
  alignmentItems,
  horizontalOverlap: 0,
  verticalOverlap: 0,
};

export default layerDefaultState;
